function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { LAYER_TYPE, LAYER_HOVER, WFS_ID_KEY, FTR_PROPERTY_ID, LAYER_ID, VECTOR_TILE_TYPE, VECTOR_TYPE } from '../domain/constants';
import { getStylesForGeometry } from '../oskariStyle/generator.ol';
import olOverlay from 'ol/Overlay';
import olLayerVector from 'ol/layer/Vector';
import olLayerVectorTile from 'ol/layer/VectorTile';
import { Vector as olSourceVector } from 'ol/source';
var STROKE_ADDITION = 2;
export var HoverHandler = /*#__PURE__*/function () {
  function HoverHandler(mapmodule) {
    _classCallCheck(this, HoverHandler);
    this._mapmodule = mapmodule;
    this._vectorTileLayers = {};
    this._hoverLayer = null;
    this._styleCache = {};
    this._state = {};
    this._styleFactory = null;
    this._tooltipContents = {};
    this._tooltipOverlay = null;
    this._defaultStyles = {};
    this._initBindings();
  }
  return _createClass(HoverHandler, [{
    key: "_initBindings",
    value: function _initBindings() {
      var _this = this;
      this._mapmodule.getMap().getViewport().addEventListener('mouseout', function (evt) {
        _this.clearHover();
      }, false);
      this._styleFactory = this._mapmodule.getGeomTypedStyles.bind(this._mapmodule);
      var olLayer = new olLayerVector({
        source: new olSourceVector()
      });
      olLayer.set(LAYER_HOVER, true, true);
      this._mapmodule.addLayer(olLayer);
      this._hoverLayer = olLayer;
    }

    /**
     * @method onMapHover VectorFeatureService handler impl method
     * Handles feature highlighting on map hover.
     *
     * @param { Oskari.mapframework.event.common.MouseHoverEvent } event
     * @param { olRenderFeature } feature
     * @param { olVectorTileLayer } olLayer
     */
  }, {
    key: "onFeatureHover",
    value: function onFeatureHover(event, feature, olLayer) {
      if (!feature || !olLayer) {
        this.clearHover();
        return;
      }
      var layerType = olLayer.get(LAYER_TYPE);
      if (this._featureOrIdEqualsCurrent(feature, layerType)) {
        return;
      }
      this._clearState();
      var layerId = olLayer.get(LAYER_ID);
      this.updateTooltipContent(layerId, feature);
      var layerChanged = this._state.layerId !== layerId;
      this._state = {
        feature: feature,
        layerId: layerId
      };
      // Vectorhandler updates vector layers' feature styles but tooltip is handled by hoverhandler
      if (layerType === VECTOR_TYPE) {
        return;
      }
      // Try first if layer has stored vectorlayer
      var vtLayer = this._vectorTileLayers[layerId];
      if (vtLayer) {
        var idProp = this._getIdProperty(layerType);
        this._state.renderFeatureId = feature.get(idProp);
        vtLayer.changed();
        return;
      }
      if (layerChanged) {
        this.onLayerChange(layerId);
      }
      this._hoverLayer.getSource().addFeature(feature);
    }
  }, {
    key: "onMapHover",
    value: function onMapHover(event) {
      this._updateTooltipPosition(event);
    }
  }, {
    key: "updateHoverLayer",
    value: function updateHoverLayer(layer, hidden) {
      var layerId = layer.getId();
      if (this._state.layerId !== layerId) {
        return;
      }
      if (hidden) {
        this.clearHover();
        return;
      }
      this._hoverLayer.setOpacity(layer.getOpacity() / 100);
    }
  }, {
    key: "onLayerChange",
    value: function onLayerChange(layerId) {
      var layer = Oskari.getSandbox().findMapLayerFromSelectedMapLayers(layerId);
      if (!layer) {
        // this happens when reseting the map state while a feature is being hovered on
        return;
      }
      var mapmodule = this._mapmodule;
      var hoverLayer = this._hoverLayer;
      var olLayers = mapmodule.getOLMapLayers(layerId);
      // assumes that first layer is main layer and others are straight over main layer
      var topLayer = olLayers[olLayers.length - 1];
      var index = mapmodule.getLayerIndex(topLayer);
      mapmodule.setLayerIndex(hoverLayer, index + 1);
      hoverLayer.setOpacity(layer.getOpacity() / 100);
      hoverLayer.setStyle(this.getCachedStyle(layerId));
      hoverLayer.changed();
    }

    // VectorTile uses lightweight and read-only RenderFeature
    // create copy with same source and hover style
  }, {
    key: "createVectorTileLayer",
    value: function createVectorTileLayer(layer, source) {
      var olLayer = new olLayerVectorTile({
        source: source
      });
      olLayer.setOpacity(layer.getOpacity());
      olLayer.setVisible(layer.isVisible());
      olLayer.set(LAYER_HOVER, true, true);
      olLayer.setStyle(this._styleGenerator(layer, true));
      this._vectorTileLayers[layer.getId()] = olLayer;
      this.setTooltipContent(layer);
      return olLayer;
    }
  }, {
    key: "registerLayer",
    value: function registerLayer(layer) {
      this.setTooltipContent(layer);
      this._styleCache[layer.getId()] = this._styleGenerator(layer);
    }
  }, {
    key: "removeLayer",
    value: function removeLayer(layer) {
      var layerId = layer.getId();
      if (this._state.layerId === layerId) {
        this.clearHover(true);
      }
      delete this._styleCache[layerId];
      delete this._vectorTileLayers[layerId];
    }
  }, {
    key: "updateLayerStyle",
    value: function updateLayerStyle(layer) {
      var layerId = layer.getId();
      if (this._state.layerId === layerId) {
        this.clearHover(true);
      }
      this.setTooltipContent(layer);
      var vectorTileLayer = this._vectorTileLayers[layerId];
      if (vectorTileLayer) {
        vectorTileLayer.setStyle(this._styleGenerator(layer, true));
        return;
      }
      if (this._styleCache[layerId]) {
        this._styleCache[layerId] = this._styleGenerator(layer);
      }
    }
  }, {
    key: "getCachedStyle",
    value: function getCachedStyle(layerId) {
      return this._styleCache[layerId]; // || defaultStyle;
    }
  }, {
    key: "setTooltipContent",
    value: function setTooltipContent(layer) {
      var options = typeof layer.getHoverOptions === 'function' ? layer.getHoverOptions() : {};
      if (!options || !Array.isArray(options.content)) {
        return;
      }
      this._tooltipContents[layer.getId()] = options.content;
    }
  }, {
    key: "setDefaultStyle",
    value: function setDefaultStyle(layerType, styleType, styleDef) {
      var styles = this._defaultStyles[layerType] || {};
      styles[styleType] = styleDef;
      this._defaultStyles[layerType] = styles;
    }
  }, {
    key: "_styleGenerator",
    value: function _styleGenerator(layer, isVectorTile) {
      var _this2 = this;
      var _ref = layer.getHoverOptions() || {},
        layerHoverDef = _ref.featureStyle;
      var _ref2 = this._defaultStyles[layer.getLayerType()] || {},
        defaultHoverDef = _ref2.hover;
      var hoverDef = layerHoverDef || defaultHoverDef;
      if (!hoverDef) {
        return null;
      }
      if (hoverDef.inherit === true) {
        hoverDef = this._getInheritedStyle(layer, hoverDef);
      }
      // TODO: if layer contains only one geometry type return olStyle (hoverDef) instead of function
      var olStyles = this._styleFactory(hoverDef);
      var layerType = layer.getLayerType();
      if (isVectorTile) {
        var idProp = this._getIdProperty(layerType);
        return function (feature) {
          if (_this2._state.renderFeatureId === feature.get(idProp)) {
            return getStylesForGeometry(feature.getType(), olStyles);
          }
        };
      }
      return function (feature) {
        return getStylesForGeometry(feature.getGeometry(), olStyles);
      };
    }
  }, {
    key: "_getInheritedStyle",
    value: function _getInheritedStyle(layer, hoverDef) {
      var _ref3 = this._defaultStyles[layer.getLayerType()] || {},
        defaultFeatureStyle = _ref3.featureStyle;
      var featureStyle = layer.getCurrentStyle().getFeatureStyle();
      var base = jQuery.extend(true, {}, defaultFeatureStyle, featureStyle);
      if (Oskari.util.keyExists(base, 'stroke.width')) {
        base.stroke.width = base.stroke.width + STROKE_ADDITION;
      }
      if (Oskari.util.keyExists(base, 'stroke.area.width')) {
        base.stroke.area.width = base.stroke.area.width + STROKE_ADDITION;
      }
      return jQuery.extend(true, {}, base, hoverDef);
    }
  }, {
    key: "_clearState",
    value: function _clearState(clearLayerId) {
      var layerId = this._state.layerId;
      // store layerId to avoid unnecessary style updates
      this._state = clearLayerId ? {} : {
        layerId: layerId
      };
      if (layerId) {
        var vtLayer = this._vectorTileLayers[layerId];
        if (vtLayer) {
          vtLayer.changed();
        } else {
          this._hoverLayer.getSource().clear(true);
        }
      }
    }
  }, {
    key: "clearHover",
    value: function clearHover(clearLayerId) {
      this._clearState(clearLayerId);
      this._clearTooltip();
    }
  }, {
    key: "_featureOrIdEqualsCurrent",
    value: function _featureOrIdEqualsCurrent(feature, layerType) {
      var current = this._state.feature;
      if (!current) {
        return false;
      }
      var idProp = this._getIdProperty(layerType);
      return current === feature || current.get(idProp) === feature.get(idProp);
    }
  }, {
    key: "_getIdProperty",
    value: function _getIdProperty(layerType) {
      // WFS layer plugin handles additional layer types which uses '_oid' key but layer type isn't wfs
      // It's clearer to check layers which uses 'id' key
      return layerType === VECTOR_TILE_TYPE || layerType === VECTOR_TYPE ? FTR_PROPERTY_ID : WFS_ID_KEY;
    }

    /**
    * @method getTooltipOverlay
    * Get common tooltip overlay.
    *
    * @return {olOverlay}
    */
  }, {
    key: "getTooltipOverlay",
    value: function getTooltipOverlay() {
      if (!this._tooltipOverlay) {
        var overlayDiv = document.createElement('div');
        overlayDiv.className = 'feature-hover-overlay';
        this._tooltipOverlay = new olOverlay({
          element: overlayDiv,
          offset: [10, -10],
          stopEvent: false
        });
        this._mapmodule.getMap().addOverlay(this._tooltipOverlay);
      }
      return this._tooltipOverlay;
    }

    /**
     * @method _getTooltipContent
     * @param {Number | } contentOptions
     * @param {olFeature | olRenderFeature} feature
     * @return {String} html content for tooltip or null
     */
  }, {
    key: "_getTooltipContent",
    value: function _getTooltipContent(layerId, feature) {
      var contentOptions = this._tooltipContents[layerId];
      if (!contentOptions) {
        return null;
      }
      var content = '';
      contentOptions.forEach(function (entry) {
        var key = entry.key;
        if (typeof key === 'undefined' && entry.keyProperty) {
          key = feature.get(entry.keyProperty);
        }
        if (typeof key !== 'undefined') {
          content += '<div>' + key;
          if (entry.valueProperty) {
            content += ': ';
            var value = feature.get(entry.valueProperty);
            if (typeof value !== 'undefined') {
              content += value;
            }
          }
          content += '</div>';
        }
      });
      if (content) {
        return content;
      }
      return null;
    }

    /**
     * @method _updateTooltipPosition
     * Updates tooltip overlay's position.
     *
     */
  }, {
    key: "_updateTooltipPosition",
    value: function _updateTooltipPosition(event) {
      var mapWidth = Oskari.getSandbox().getMap().getWidth();
      var tooltip = jQuery(this.getTooltipOverlay().getElement());
      var margin = 20;
      var positioningY = event.getPageY() > (tooltip.outerHeight() || 100) + margin ? 'bottom' : 'top';
      var positioningX = event.getPageX() + (tooltip.outerWidth() || 200) + margin < mapWidth ? 'left' : 'right';
      var positioning = positioningY + '-' + positioningX;
      this.getTooltipOverlay().setPositioning(positioning);
      this.getTooltipOverlay().setPosition([event.getLon(), event.getLat()]);
    }

    /**
     * @method updateTooltipContent
     * Updates tooltip with feature's data or hides it if content is empty.
     *
     * @param {Numbed | String} layerId
     * @param {olFeature | olRenderFeature} feature
     */
  }, {
    key: "updateTooltipContent",
    value: function updateTooltipContent(layerId, feature) {
      var tooltip = jQuery(this.getTooltipOverlay().getElement());
      var content = this._getTooltipContent(layerId, feature);
      if (content) {
        tooltip.html(content);
        tooltip.css('display', '');
      } else {
        tooltip.empty();
        tooltip.css('display', 'none');
      }
    }

    /**
     * @method _clearTooltip
     * Clears tooltip's content and hides it.
     */
  }, {
    key: "_clearTooltip",
    value: function _clearTooltip() {
      var tooltip = jQuery(this.getTooltipOverlay().getElement());
      tooltip.empty();
      tooltip.css('display', 'none');
    }
  }]);
}();